import React, { useState, useEffect } from 'react'
import './index.scss'
import {
    Input,
    Card,
    Avatar,
    Skeleton
} from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPollH,
    faTimesCircle,
    faArrowCircleDown,
    faSync,
    faSlidersH,
    faBalanceScale,
} from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import TagDuoTone from "../../../iconComponent/TagDuoTone";
import { StaticImage } from '../../../../utils/image';
import { ConvertDateShort } from '../../../../utils/date';
import { checkComplete, checkLeftTime, checkLeftTimeIcon, checkLeftTimeStatus } from '../../../../utils';
import ProgressBar from "../../progressBar";
import ProjectCardItem from './project';
import SurveyCardSubItem from './subCard';
import { useHistory } from 'react-router-dom';
import { encodeBase64 } from '../../../../utils/convertBase64';
const { Search } = Input;

const listTextOption = [
    { value: '', label: "ทั้งหมด" },
    { value: "O", label: "เปิดรับฟัง" },
    { value: "I", label: "ปิดรับฟัง" },
];

const SurveyCardV2 = ({ surveys = [], law_group, entitys = [], handleFavorite, agencyOption, ministryOption, surveyTypeOption, getFilterSurvey }) => {
    const [agency, setagency] = useState(null);
    const [ministry, setministry] = useState(null);
    const [surveyType, setsurveyType] = useState(null);
    const [statusSurvey, setStatusSurvey] = useState(null);
    const [searchFilter, setSearchFilter] = useState("");

    const cleardata = () => {
        setSearchFilter("");
        setStatusSurvey(null);
        setagency(null);
        setministry(null);
        setsurveyType(null);
    };

    useEffect(() => {
        getFilterSurvey({
            ministry,
            agency,
            surveyType,
            statusSurvey,
            searchFilter,
        });
        return () => { };
    }, [agency, ministry, surveyType, statusSurvey, searchFilter]);

    return (
        <div id="survey-card-container-v2-mobile">
            <div className="survey-card-container">
                {surveys.map((item, index) =>
                    <SurveyCardItem
                        key={"survey_" + item.survey_id}
                        survey={item}
                        law_group={law_group}
                        entitys={
                            entitys.filter(x => x.project_type_id == item.project.project_type_id && x.order_id != 98 && x.order_id != 99)
                        }
                        handleFavorite={handleFavorite} />)}
            </div>
        </div>
    )
}

const SurveyCardItem = ({ survey, law_group, entitys, handleFavorite }) => {
    const history = useHistory();
    const [isCollapse, setIsCollapse] = useState(false);
    const renderImageLawGroup = (item) => {
        let law = "";
        if (item.law_group_id) {
            const split = item.law_group_id.split(",");
            law = law_group.find((x) => x.lawgroup_id == split[0]);
        }

        return (
            <div className="law-group-container-mobile d-flex-center">
                <div className="d-flex-center">
                    {law && law.image ? (
                        <Avatar
                            alt="image of law group"
                            className="avatar-object-contain !h-8 !w-8"
                            size={{
                                xs: 24,
                                sm: 24,
                                md: 24,
                                lg: 24,
                                xl: 24,
                                xxl: 24,
                            }}
                            style={{
                                height: 24,
                                width: 24,
                            }}
                            // shape={'circle'}
                            src={law.image}
                        />
                    ) : (
                        <Skeleton.Button active={true} size={24} shape={"circle"} />
                    )}
                </div>
            </div>
        );
    };
    const renderLawGroupText = (item) => {
        let law = "ไม่ได้ระบุ";
        if (item.law_group_id) {
            const split = item.law_group_id.split(",");
            law = law_group.filter((x) => split.includes(x.lawgroup_id.toString()));
            law = law.length > 0 ? law.map(x => x.lawgroup_name).join(',') : "-";
        }

        return (
            <div
                className="d-flex discuss-container"
            >
                <img
                    src={StaticImage("/images/icon/books-duotone-1-copy.svg")}
                    style={{ marginRight: 5 }}
                    alt="webboard"
                    height={18}
                />
                <label className="lawgroup-text" style={{ color: "#333" }}>
                    {law}
                </label>
            </div>
        );
    };
    const renderAnswerCount = (survey) => {
        let answer_count = survey.answer_count ?? 0;
        return (
            <div className="d-flex discuss-container" style={{ marginRight: 15 }}>
                <div className="badge-answer">{answer_count}</div>
            </div>
        );
    };
    const renderPublishNo = (survey) => {
        return (
            <div className="d-flex discuss-container" style={{ paddingRight: 7.5 }}>
                <img
                    src={StaticImage("/images/icon/pen-nib-duotone.svg")}
                    style={{ marginRight: 5 }}
                    height={24}
                    alt="public-no"
                />
                <div className="d-flex" style={{ alignItems: 'center' }}>
                    <span>ครั้งที่</span>
                    <div className="badge-public">{survey.publish_no}</div>
                </div>
            </div>
        );
    };

    const collapse = (e, item) => {
        e.stopPropagation();
        setIsCollapse(!isCollapse);
    };

    const navigate = (survey_id) => {
        history.push(`/listeningDetail?survey_id=${encodeBase64(survey_id)}`);
    }

    const renderFavorite = (survey) => {
        return (
            survey.is_like === true ? (
                <img
                    height={32}
                    width={32}
                    src={StaticImage(
                        "/images/icon/header/heart-circle-duotone-2-active.svg"
                    )}
                    alt="favorite"
                />
            ) : (
                <img
                    height={32}
                    width={32}
                    className="cursor-pointer"
                    onMouseOver={(e) =>
                    (e.currentTarget.src = StaticImage(
                        "/images/icon/header/heart-circle-duotone-2-active.svg"
                    ))
                    }
                    onMouseOut={(e) =>
                    (e.currentTarget.src = StaticImage(
                        "/images/icon/header/heart-circle-duotone-2.svg"
                    ))
                    }
                    src={StaticImage(
                        "/images/icon/header/heart-circle-duotone-2.svg"
                    )}
                    alt="favorite"
                />
            )
        );
    }

    const renderDate = () => {
        return (
            <div className="d-flex-align-center">
                <img
                    src={StaticImage(checkLeftTimeIcon(survey) ? "/images/icon/vote-yea-duotone.svg" : "/images/icon/vote-nay-duotone.svg")}
                    style={{ marginRight: 5 }}
                    height={16}
                    alt="public-no"
                />
                <div className="d-flex" style={{ alignItems: 'center' }}>
                    <span>
                        {`${ConvertDateShort(survey.start_date, "DD MMM YY")} - ${ConvertDateShort(survey.end_date, "DD MMM YY")}`}
                    </span>
                </div>
            </div>
        );
    };
    const renderStatus = () => {
        return (
            checkLeftTimeStatus(survey)
        );
    };

    return (
        <section style={{ marginBottom: 20 }}>
            {/* <div className="survey-card" onClick={() => navigate(survey.survey_id)}>
                <div className="d-flex row1">
                    <div className="d-flex-align-center flex-1">
                        {renderImageLawGroup(survey)}
                        {survey.agency_id > 0 && (
                            <div
                                className="organize-container"
                                style={{ margin: 0, marginRight: 15 }}
                            >
                                <img
                                    alt="agency_image"
                                    src={survey.agency_image_uploaded ?? survey.agency_image}
                                    className="logo"
                                    oncontextmenu="return false;"
                                    onError={(i) => (i.target.style.display = "none")}
                                />
                                <label style={{ paddingLeft: "2px" }}>
                                    {survey.agency_short ?? survey.agency_abbrv}
                                </label>
                            </div>
                        )}
                        <div className="project-type">
                            <TagDuoTone />
                            <span>
                                {survey.survey_type_name}
                            </span>
                        </div>

                    </div>
                    <div onClick={(e) => handleFavorite(e, survey)}>
                        <div class="group relative py-2">
                            {renderFavorite(survey)}
                            <div class="hidden group-hover:block ...">ถูกใจ</div>
                        </div>
                    </div>
                </div>
                <div className="column2">
                    <div className="d-flex">
                        <label className="title flex-1">{survey.short_project_name ?? survey.project_name}</label>
                    </div>
                    <label className="description">
                        {survey.short_survey_name ?? survey.survey_name}
                    </label>
                    <div className="webboard-row">
                        {renderLawGroupText(survey)}
                    </div>
                    <div className="webboard-row">
                        <div className="d-flex-align-center flex-1">
                            <div className="d-flex discuss-container">
                                <img
                                    src={StaticImage("/images/icon/users-class-light.svg")}
                                    style={{ marginRight: 10 }}
                                    alt="webboard"
                                />
                                <label style={{ color: "#488345" }}>
                                    ร่วมเสนอ
                                </label>
                            </div>
                            {renderAnswerCount(survey)}
                            {renderPublishNo(survey)}
                        </div>
                        <div className="d-flex expand cursor-pointer">
                            <div className="badge-public">{survey.surveys.length + 1}</div>
                            <div class="d-flex" style={{ alignItems: 'center' }} onClick={(e) => collapse(e, survey)}>
                                <span style={{ marginRight: 5 }}>{!isCollapse ? 'ขยาย' : 'ปิด'}</span>
                                <img
                                    src={StaticImage(!isCollapse ? "/images/icon/chevron-circle-down.svg" : "/images/icon/chevron-circle-up.png")}
                                    style={{ marginRight: 5 }}
                                    height={14}
                                    alt="public-no"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="progressbar-row">
                        <div style={{ display: "flex", flex: 1, paddingRight: 7.5 }}>
                            {checkLeftTimeIcon(survey) ? <>
                                <img
                                    src={StaticImage(checkLeftTimeIcon(survey) ? "/images/icon/vote-yea-duotone.svg" : "/images/icon/vote-nay-duotone.svg")}
                                    style={{ marginRight: 5 }}
                                    height={14}
                                    alt="public-no"
                                />
                                <span style={{ fontSize: 12 }}>
                                    {ConvertDateShort(survey.start_date, "DD MMM YY")}
                                </span>
                                <section
                                    className="progress-list-filter"
                                    style={{ width: "100%", maxWidth: 200 }}
                                >
                                    <ProgressBar
                                        bgcolor={survey.date_balance > 7 ? "#387436" : "#f96b57"}
                                        bgContainerColor={
                                            survey.date_balance > 7 ? "#e4e8f0" : "#e4e8f0"
                                        }
                                        leftTime={checkLeftTime(survey)}
                                        completed={checkComplete(survey)}
                                    />
                                </section>
                                <span>
                                    <span style={{ fontSize: 12 }}>
                                        {ConvertDateShort(survey.end_date, "DD MMM YY")}
                                    </span>
                                </span>
                            </>
                                :
                                <>
                                    {renderDate()}
                                    {renderStatus()}
                                </>
                            }

                        </div>
                    </div>
                </div>
            </div> */}
            <div className="survey-card" onClick={() => navigate(survey.survey_id)}>
                <div className='flex gap-x-4'>
                    <div className='flex-col gap-y-2 flex min-w-[75px] max-w-[75px] items-center'>
                        {renderImageLawGroup(survey)}
                        {survey.agency_id > 0 && (
                            <div
                                className="rounded-lg py-1 flex flex shadow-lg bg-[#f4f6f9] px-2 gap-x-1 items-center justify-center"
                            >
                                <img
                                    alt="agency_image"
                                    src={survey.agency_image_uploaded ?? survey.agency_image}
                                    className="logo w-5 h-5 rounded-[100%] bg-white"
                                    oncontextmenu="return false;"
                                    onError={(i) => (i.target.style.display = "none")}
                                />
                                <label className='text-xs line-clamp-2' style={{ paddingLeft: "2px" }}>
                                    {survey.agency_short ?? survey.agency_abbrv}
                                </label>
                            </div>
                        )}
                    </div>

                    <div className='flex-1 flex-col gap-y-1'>
                        <label className="text-sm font-semibold">{survey.short_project_name ?? survey.project_name}</label>
                        <label className="line-clamp-2 text-xs text-black">
                            {survey.short_survey_name ?? survey.survey_name}
                        </label>
                        <div className='flex mt-1 flex-wrap gap-y-2 gap-x-2'>
                            <div className=''>
                                {renderLawGroupText(survey)}
                            </div>
                            <div className='flex gap-x-1 items-center'>
                                <img
                                    className='w-5 h-5'
                                    src={StaticImage("/images/icon/users-class-light.svg")}
                                    alt="webboard"
                                />
                                <label className='text-sm' style={{ color: "#488345" }}>
                                    ร่วมเสนอ
                                </label>
                                <div className='bg-[#488345] text-white rounded-sm flex items-center justify-center px-1 text-xs h-fit'>{survey.answer_count ?? 0}</div>
                                <div className='flex items-center gap-x-1'>
                                    <img
                                        className='w-4 h-4'
                                        src={StaticImage("/images/icon/pen-nib-duotone.svg")}
                                        height={24}
                                        alt="public-no"
                                    />
                                    <div className="d-flex gap-x-1" style={{ alignItems: 'center' }}>
                                        <span>ครั้งที่</span>
                                        {/* <div className="badge-public">{survey.publish_no}</div> */}
                                        <div className='bg-[#0e4ea3] text-white rounded-sm flex items-center justify-center px-1 text-xs h-fit'>{survey.publish_no}</div>
                                    </div>
                                </div>

                            </div>
                            <div className="flex items-center gap-x-1 flex-1 justify-end">
                                <div className='border-l-2 w-1 h-4'></div>
                                {/* <div className='bg-[#0e4ea3] text-white rounded-sm flex items-center justify-center px-1 text-xs h-fit'>{survey.surveys.length + 1}</div> */}
                                <div class="d-flex" style={{ alignItems: 'center' }} onClick={(e) => collapse(e, survey)}>
                                    <span style={{ marginRight: 5 }}>{!isCollapse ? 'ขยาย' : 'ปิด'}</span>
                                    <img
                                        src={StaticImage(!isCollapse ? "/images/icon/chevron-circle-down.svg" : "/images/icon/chevron-circle-up.png")}
                                        style={{ marginRight: 5 }}
                                        height={14}
                                        alt="public-no"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex mt-2 flex-wrap gap-y-2 gap-x-2 justify-between items-center'>
                    <div className="flex gap-x-1 items-center">
                        <TagDuoTone className={"w-4 h-4 text-[#0c4da2]"} />
                        <span className='text-sm'>
                            {survey.survey_type_name}
                        </span>
                    </div>
                    <div className="progressbar-row gap-x-2 whitespace-nowrap !text-xs items-center">
                        <div className='gap-x-1 items-center' style={{ display: "flex", flex: 1, paddingRight: 7.5 }}>
                            {checkLeftTimeIcon(survey) ? <>
                                <img
                                    src={StaticImage(checkLeftTimeIcon(survey) ? "/images/icon/vote-yea-duotone.svg" : "/images/icon/vote-nay-duotone.svg")}
                                    height={14}
                                    alt="public-no"
                                />
                                <span style={{ fontSize: 12 }}>
                                    {ConvertDateShort(survey.start_date, "DD MMM YY")}
                                </span>
                                <ProgressBar
                                    bgcolor={survey.date_balance > 7 ? "#387436" : "#f96b57"}
                                    bgContainerColor={
                                        survey.date_balance > 7 ? "#717377" : "#717377"
                                    }
                                    bgContainerClass={'!w-fit'}
                                    leftTime={checkLeftTime(survey)}
                                    completed={checkComplete(survey)}
                                />
                                <span>
                                    <span style={{ fontSize: 12 }}>
                                        {ConvertDateShort(survey.end_date, "DD MMM YY")}
                                    </span>
                                </span>
                            </>
                                :
                                <>
                                    {renderDate()}
                                    {/* {renderStatus()} */}
                                </>
                            }

                        </div>
                    </div>
                </div>
            </div>
            {isCollapse && <ProjectCardItem project={survey.project} entitys={entitys} survey={survey} />}
            {(isCollapse && survey.surveys.length > 0) && survey.surveys.map(sub => {
                return <SurveyCardSubItem survey={sub} />
            })}
        </section>
    )
}



export default SurveyCardV2;